import Form from '@rjsf/mui'
import { JSONSchema7Object } from 'json-schema'
import { useContext, useRef, useState } from 'react'
import { useFormContext } from 'react-hook-form'

import { IChangeEvent } from '@rjsf/mui/dist'
import { RJSFSchema, RJSFValidationError } from '@rjsf/utils/dist'
import validator from '@rjsf/validator-ajv8'
import { ErrorContext } from 'context/error/ErrorContext'
import ConfiguratorOptionTreeMultiple from './ConfiguratorOptionTreeMultiple'

interface IConfiguratorOptionProps {
    selectedRootModelCode: string
    initialData?: string
}

const ConfiguratorOption = ({ selectedRootModelCode, initialData }: IConfiguratorOptionProps) => {
    const { setValue } = useFormContext()
    const { setErrorState } = useContext(ErrorContext)
    const [formData, setFormData] = useState<unknown>(JSON.parse(initialData ?? '{}'))
    const formDataRef = useRef<unknown>(JSON.parse(initialData ?? '{}'))

    const Schema = JSON.parse(`
      {
        "type": "object",
        "properties": {
          "Options": {
            "type": "array",
            "title": "Options",
            "items": {
              "type": "object",
              "properties":{
                "path": { "type":"string", "title":"Option" },
                "label": { "type":"string", "title":"Comparison Label" },
                "description": { "type":"string", "title":"Description" },
                "is_default_path": {"type":"boolean", "title":"Is Default Option", "default":false}
              }
            }
          }
        }
      }
    `)

    const uiSchema = {
        Options: {
            'ui:ArrayFieldTemplate': (props: any) => {
                const { items, registry } = props
                const ArrayFieldTemplate = registry.templates.ArrayFieldTemplate

                // Customize the items to show "1. Options", "2. Options", etc.
                const customItems = items.map((item: any, index: number) => ({
                    ...item,
                    children: {
                        ...item.children,
                        props: {
                            ...item.children.props,
                            title: `${index + 1}. Options`
                        }
                    }
                }))

                return <ArrayFieldTemplate {...props} items={customItems} />
            },
            items: {
                path: {
                    'ui:widget': ConfiguratorOptionTreeMultiple
                }
            }
        }
    }

    const onChangeHandler = (e: IChangeEvent<any, RJSFSchema, any>) => {
        // Store in ref to avoid re-renders, but don't call setFormData
        formDataRef.current = e.formData
        setValue('included_options', JSON.stringify(e.formData))
    }

    const OnErrorHandler = (errors: JSONSchema7Object[]) => {
        setErrorState({ hasError: true, message: errors[0].stack as string })
    }

    const TransformErrors = (errors: RJSFValidationError[]) => {
        return errors?.map((error: RJSFValidationError) => {
            console.warn(error)
            return error
        })
    }

    return (
        <div style={{ width: '100%' }}>
            <Form
                schema={Schema}
                uiSchema={uiSchema}
                formData={formData}
                children={true}
                onChange={(e) => onChangeHandler(e)}
                onError={(e) => OnErrorHandler(e)}
                transformErrors={TransformErrors}
                validator={validator}
            ></Form>
        </div>
    )
}

export default ConfiguratorOption
